var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
}

(function() {
  const translations = window.theme && window.theme.strings ? window.theme.strings : {};

  function validateMinOrder(cartContainer) {
    const cartItems = cartContainer.querySelectorAll('[data-min-order]');
    const errors = [];
    
    cartItems.forEach(function(item) {
      const minOrder = Number(item.getAttribute('data-min-order') || 1);
      if (minOrder <= 1) return;
      
      const qtyInput = item.querySelector('.qty');
      
      if (!qtyInput) return;
      
      const quantity = Number(qtyInput.value || 0);
      
      if (quantity < minOrder) {
        errors.push({
          item: item,
          minOrder: minOrder,
          quantity: quantity,
          needed: minOrder - quantity
        });
      }
    });
    
    return errors;
  }

  function showErrorMessages(errors, cartContainer) {
    errors.forEach(function(error) {
      const item = error.item;
      const existingError = item.querySelector('.cart-item__min-order-error');
      
      if (existingError) {
        existingError.remove();
      }
      
      const errorMessage = document.createElement('div');
      errorMessage.className = 'cart-item__min-order-error';
      errorMessage.textContent = (translations.minOrderError || 'Add {{ count }} more item(s) to meet minimum order requirement').replace('{{ count }}', error.needed);
      
      const itemName = item.querySelector('.item__name');
      const itemContentName = item.querySelector('.item__content-name');
      const targetContainer = itemName || itemContentName || item.querySelector('.item__content');
      
      if (targetContainer) {
        targetContainer.appendChild(errorMessage);
      }
      
      item.classList.add('cart-item__error');
    });
  }

  function clearErrorMessages(cartContainer) {
    const errorMessages = cartContainer.querySelectorAll('.cart-item__min-order-error');
    errorMessages.forEach(function(msg) {
      msg.remove();
    });
    
    const errorItems = cartContainer.querySelectorAll('.cart-item__error');
    errorItems.forEach(function(item) {
      item.classList.remove('cart-item__error');
    });
  }

  function handleCheckoutClick(evt) {
    const target = evt.target.closest('button, a') || evt.target;
    const isCheckoutButton = target.classList.contains('btn-checkout') ||
                             (target.tagName === 'BUTTON' && target.name === 'checkout') ||
                             (target.tagName === 'A' && target.href && target.href.includes('/checkout'));
    
    if (!isCheckoutButton) return;
    
    const minCart = document.querySelector('.minicart');
    const cartPage = document.querySelector('.page-cart');
    const cartContainer = minCart || cartPage;
    
    if (!cartContainer) return;
    
    clearErrorMessages(cartContainer);
    const errors = validateMinOrder(cartContainer);
    
    if (errors.length > 0) {
      evt.preventDefault();
      evt.stopPropagation();
      
      showErrorMessages(errors, cartContainer);
      
      const firstError = errors[0].item;
      if (firstError) {
        setTimeout(function() {
          firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 100);
      }
      
      return false;
    }
  }

  function initCartValidation() {
    document.addEventListener('click', handleCheckoutClick, true);
    
    const cartForm = document.querySelector('.page-cart form[action="/cart"]');
    if (cartForm) {
      cartForm.addEventListener('submit', function(evt) {
        const submitButton = document.activeElement;
        if (submitButton && submitButton.name === 'checkout') {
          const cartPage = document.querySelector('.page-cart');
          if (cartPage) {
            clearErrorMessages(cartPage);
            const errors = validateMinOrder(cartPage);
            
            if (errors.length > 0) {
              evt.preventDefault();
              evt.stopPropagation();
              
              showErrorMessages(errors, cartPage);
              
              const firstError = errors[0].item;
              if (firstError) {
                firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
              }
              
              return false;
            }
          }
        }
      });
    }

    document.addEventListener('input', function(evt) {
      if (evt.target.classList.contains('qty')) {
        const item = evt.target.closest('[data-min-order]');
        if (item) {
          const cartContainer = item.closest('.minicart') || item.closest('.page-cart');
          if (cartContainer) {
            clearErrorMessages(cartContainer);
          }
        }
      }
    });

    document.addEventListener('change', function(evt) {
      if (evt.target.classList.contains('qty')) {
        const item = evt.target.closest('[data-min-order]');
        if (item) {
          const cartContainer = item.closest('.minicart') || item.closest('.page-cart');
          if (cartContainer) {
            clearErrorMessages(cartContainer);
          }
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartValidation);
  } else {
    initCartValidation();
  }
})();

class ProductCard extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.addEventListener("click", (event) => {
      if (
        event.target.closest(".addcart_btn") ||
        event.target.closest(".addcompare_btn")
      ) {
        return;
      }
      window.location.href = this.dataset.productUrl;
    });
  }
}
customElements.define("product-card", ProductCard);

class PriceSlider extends HTMLElement {
  constructor() {
    super();
    this.priceSlider = null;
    this.minInput = null;
    this.maxInput = null;
    this.hiddenMinInput = null;
    this.hiddenMaxInput = null;
    this.rangeText = null;
    this.rangeMin = 0;
    this.rangeMax = 0;
    this.currentMin = 0;
    this.currentMax = 0;
    this.updateTimeout = null;
    this.lastSubmittedMin = 0;
    this.lastSubmittedMax = 0;
  }

  connectedCallback() {
    this.priceSlider = this.querySelector('.filter-price-sliderr');
    this.minInput = this.querySelector('.price-input.min-price');
    this.maxInput = this.querySelector('.price-input.max-price');
    this.hiddenMinInput = this.querySelector('.filter-price--min');
    this.hiddenMaxInput = this.querySelector('.filter-price--max');
    this.rangeText = this.querySelector('.filter-price-range');

    this.rangeMin = parseFloat(this.priceSlider.dataset.rangemin) || 0;
    this.rangeMax = parseFloat(this.priceSlider.dataset.rangemax) || 1000;
    
    this.currentMin = this.minInput.value ? 
      Math.max(this.rangeMin, parseFloat(this.minInput.value)) : this.rangeMin;
    this.currentMax = this.maxInput.value ? 
      Math.min(this.rangeMax, parseFloat(this.maxInput.value)) : this.rangeMax;
    
    if (this.currentMin > this.currentMax) {
      this.currentMin = this.rangeMin;
      this.currentMax = this.rangeMax;
    }
    
    this.lastSubmittedMin = this.currentMin;
    this.lastSubmittedMax = this.currentMax;

    this.minInput.value = Math.round(this.currentMin);
    this.maxInput.value = Math.round(this.currentMax);
    this.updateRangeText();

    if (typeof noUiSlider === 'object') {
      this.initializeSlider();
    }

    this.setupEventListeners();
  }

  initializeSlider() {
    noUiSlider.create(this.priceSlider, {
      start: [this.currentMin, this.currentMax],
      connect: true,
      step: 1,
      range: {
        'min': this.rangeMin,
        'max': this.rangeMax
      }
    });

    this.priceSlider.noUiSlider.on('update', (values, handle) => {
      const newMin = Math.round(values[0]);
      const newMax = Math.round(values[1]);

      if (handle === 0 && newMin !== this.currentMin) {
        this.currentMin = newMin;
        this.minInput.value = this.currentMin;
      } else if (handle === 1 && newMax !== this.currentMax) {
        this.currentMax = newMax;
        this.maxInput.value = this.currentMax;
      }

      this.updateRangeText();
      this.updateHiddenInputs();
    });
  }

  setupEventListeners() {
    this.minInput.addEventListener('change', () => this.handleInputChange());
    this.maxInput.addEventListener('change', () => this.handleInputChange());
    
    this.minInput.addEventListener('keyup', (e) => {
      if (e.key === 'Enter') this.handleInputChange();
    });
    
    this.maxInput.addEventListener('keyup', (e) => {
      if (e.key === 'Enter') this.handleInputChange();
    });
  }

  handleInputChange() {
    let newMin = parseInt(this.minInput.value) || this.rangeMin;
    let newMax = parseInt(this.maxInput.value) || this.rangeMax;

    newMin = Math.max(this.rangeMin, Math.min(newMin, this.rangeMax));
    newMax = Math.min(this.rangeMax, Math.max(newMax, this.rangeMin));

    if (newMin > newMax) {
      if (document.activeElement === this.minInput) {
        newMin = this.currentMin;
        this.minInput.value = this.currentMin;
      } else {
        newMax = this.currentMax;
        this.maxInput.value = this.currentMax;
      }
      return;
    }

    this.currentMin = newMin;
    this.currentMax = newMax;

    if (this.priceSlider.noUiSlider) {
      this.priceSlider.noUiSlider.set([this.currentMin, this.currentMax]);
    }

    this.updateRangeText();
    this.updateHiddenInputs();
  }

  updateRangeText() {
    if (this.rangeText) {
      this.rangeText.textContent = `${this.currentMin} - ${this.currentMax}`;
    }
  }

  updateHiddenInputs() {
    this.hiddenMinInput.value = this.currentMin;
    this.hiddenMaxInput.value = this.currentMax;

    clearTimeout(this.updateTimeout);
    this.updateTimeout = setTimeout(() => {
      if (this.currentMin !== this.lastSubmittedMin || this.currentMax !== this.lastSubmittedMax) {
        this.lastSubmittedMin = this.currentMin;
        this.lastSubmittedMax = this.currentMax;
        this.dispatchFormUpdate();
      }
    }, 1000);
  }

  dispatchFormUpdate() {
    const event = new Event('input', {
      bubbles: true,
      cancelable: true,
    });
    const form = this.closest('form');
    if (form) {
      form.dispatchEvent(event);
    }
  }

  disconnectedCallback() {
    if (this.priceSlider && this.priceSlider.noUiSlider) {
      this.priceSlider.noUiSlider.destroy();
    }
  }
}

customElements.define('price-slider', PriceSlider);

/* ── Active filters: remove individual filter tag without page reload ── */
document.addEventListener('click', (e) => {
  const removeBtn = e.target.closest('.active-filters__remove');
  if (!removeBtn) return;

  const form = document.getElementById('CollectionFiltersForm');
  if (!form) return;

  e.preventDefault();

  if (removeBtn.dataset.filterType === 'price_range') {
    // Clear price range hidden inputs
    const minInput = form.querySelector('.filter-price--min');
    const maxInput = form.querySelector('.filter-price--max');
    if (minInput) minInput.value = '';
    if (maxInput) maxInput.value = '';

    // Reset noUiSlider to full range if initialized
    const slider = form.querySelector('.filter-price-slider');
    if (slider && slider.noUiSlider) {
      const rmin = parseInt(slider.dataset.rangemin, 10);
      const rmax = parseInt(slider.dataset.rangemax, 10);
      slider.noUiSlider.set([rmin, rmax]);
    }
  } else {
    // Uncheck the matching checkbox in the filter form
    const paramName = removeBtn.dataset.paramName;
    const paramValue = removeBtn.dataset.paramValue;
    const input = form.querySelector(
      `input[type="checkbox"][name="${paramName}"][value="${paramValue}"]`
    );
    if (input) {
      input.checked = false;
      input.closest('.filter-tag')?.classList.remove('active');
    }
  }

  // Trigger the existing AJAX filter handler
  form.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
});


/* ── Filter group reset button (collection-filter.liquid) ── */
document.addEventListener('click', (e) => {
  const resetBtn = e.target.closest('[data-filter-group-reset]');
  if (!resetBtn) return;

  const widget = resetBtn.closest('.site-widget.filtering');
  if (!widget) return;

  // Uncheck all checked inputs in this filter group and clear active states
  widget.querySelectorAll('input[type="checkbox"]:checked').forEach(input => {
    input.checked = false;
    input.closest('.filter-tag')?.classList.remove('active');
  });

  // Hide button immediately before AJAX re-renders
  resetBtn.style.display = 'none';

  // Trigger the form's AJAX update handler
  const form = resetBtn.closest('form');
  if (form) {
    form.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
  }
});

document.addEventListener("DOMContentLoaded", () => {
  function updateBackgroundHeight() {
    let maxBottomPosition = 0;
    const bgImage = document.querySelector(".absolute_bg_top");
    
    if (!bgImage) {
      return;
    }
    
    document.querySelectorAll(".triger-bg--js").forEach(el => {
      const rect = el.getBoundingClientRect();
      const bottomPosition = rect.top + window.scrollY + rect.height;
      if (bottomPosition > maxBottomPosition) {
        maxBottomPosition = bottomPosition;
        if (document.querySelector('body').classList.contains('template-blog')){
          maxBottomPosition = maxBottomPosition - 15
        }
      }
    });
    let firstEl = document.querySelectorAll(".triger-bg--js")[0]
    if(maxBottomPosition == firstEl.getBoundingClientRect().top + window.scrollY + firstEl.getBoundingClientRect().height){
      maxBottomPosition += 20
    }
    
    bgImage.style.height = maxBottomPosition + 'px';
  }
  // ── Single-filter placement ─────────────────────────────────────────────────────
  // One <details class="collection-page--filters-drop"> is rendered inside
  // .collection--aside__wrapper (desktop). On mobile we move it into
  // .collection-page--title so the existing mobile CSS rules apply.
  // On resize back to desktop we restore the original position.

  function initFilterPlacement() {
    const asideWrapper = document.querySelector('.collection--aside__wrapper');
    const titleDiv     = document.querySelector('.collection-page--title');
    if (!asideWrapper || !titleDiv) return;

    // Element may already be in either location — find it wherever it is.
    const filterDetails =
      asideWrapper.querySelector('.collection-page--filters-drop') ||
      titleDiv.querySelector('.collection-page--filters-drop');
    if (!filterDetails) return;

    const overlayDiv = titleDiv.querySelector('.sidebar__overlay');

    if (window.innerWidth <= 991) {
      if (filterDetails.parentElement !== titleDiv) {
        titleDiv.insertBefore(filterDetails, overlayDiv || null);
        filterDetails.removeAttribute('open'); // collapsed by default on mobile
      }
    } else {
      if (filterDetails.parentElement !== asideWrapper) {
        asideWrapper.insertBefore(filterDetails, asideWrapper.firstChild);
        filterDetails.setAttribute('open', ''); // always expanded on desktop
      }
    }
  }

  // Bind header z-index handler once — the element stays in DOM across moves.
  function bindFilterHeaderZIndex() {
    const filterDetails = document.querySelector('.collection-page--filters-drop');
    const header = document.querySelector('.cstm-header');
    if (!filterDetails || !header) return;

    filterDetails.addEventListener('click', () => {
      if (window.innerWidth > 991) return;
      setTimeout(() => {
        const mobileMenu = document.querySelector('mobile-menu');
        const menuOpen = mobileMenu &&
          mobileMenu.querySelector('.header--mobile-menu--close')?.style.display === 'flex';
        if (!menuOpen) {
          header.style.zIndex = filterDetails.open ? '1' : '';
        }
      }, 1);
    });
  }

  initFilterPlacement();
  bindFilterHeaderZIndex();
  updateBackgroundHeight();
  window.addEventListener('resize', () => {
    initFilterPlacement();
    updateBackgroundHeight();
  });
  window.addEventListener('load', updateBackgroundHeight);

  /* WCAG 1.4.13 — dismiss tooltips with Escape key */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.has-tooltip .tooltip').forEach(function(tip) {
        tip.style.visibility = 'hidden';
      });
    }
  });

  /* Lower floating widgets when PhotoSwipe is open */
  const pswpEl = document.querySelector('.pswp');
  if (pswpEl) {
    const pswpObserver = new MutationObserver(() => {
      const isOpen = pswpEl.classList.contains('pswp--open');
      const targets = [
        document.querySelector('#rps_sticky_widget'),
        document.querySelector('.loox-float-toggler-container-right'),
      ];

      targets.forEach(el => {
        if (!el) return;
        if (isOpen) {
          if (!('pswpOriginalZindex' in el.dataset)) {
            el.dataset.pswpOriginalZindex = el.style.zIndex || '';
          }
          el.style.zIndex = '4';
        } else {
          el.style.zIndex = el.dataset.pswpOriginalZindex || '';
          delete el.dataset.pswpOriginalZindex;
        }
      });
    });

    pswpObserver.observe(pswpEl, { attributes: true, attributeFilter: ['class'] });
  }
});

/* ── New product card: add-to-cart loader ────────────────────────────────── */
(function () {
  function setLoading(btn) {
    if (btn.dataset.originalHtml) return;
    btn.dataset.originalHtml = btn.innerHTML;
    btn.classList.add('addcart_btn--loading');
    btn.innerHTML = '<span class="addcart-spinner"></span>';
    btn.style.pointerEvents = 'none';
  }

  function resetBtn(btn) {
    if (!btn.dataset.originalHtml) return;
    btn.innerHTML = btn.dataset.originalHtml;
    delete btn.dataset.originalHtml;
    btn.classList.remove('addcart_btn--loading');
    btn.style.pointerEvents = '';
  }

  function initNewProductCardBtns() {
    document.querySelectorAll('.new-product-card form[action="/cart/add"]').forEach(function (form) {
      if (form.dataset.cartLoaderInit) return;
      form.dataset.cartLoaderInit = '1';

      var btn = form.querySelector('.addcart_btn');
      if (!btn) return;

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        // Stop bubbling so the document-level jQuery handler in theme.js
        // doesn't fire a second add-to-cart request.
        e.stopPropagation();

        if (btn.dataset.originalHtml) return; // already in flight

        setLoading(btn);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        })
          .then(function (r) {
            if (!r.ok) throw new Error('cart/add failed');
            return r.json();
          })
          .then(function () {
            if (window.theme && theme.MiniCart) {
              theme.MiniCart.update().done(function () {
                resetBtn(btn);
                theme.MiniCart.open();
              });
            } else {
              resetBtn(btn);
            }
          })
          .catch(function () {
            resetBtn(btn);
          });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNewProductCardBtns);
  } else {
    initNewProductCardBtns();
  }

  // Re-init after dynamic section loads (collections-tabs, sliders, etc.)
  document.addEventListener('shopify:section:load', initNewProductCardBtns);
})();